$('.js-globalDialogClose').on('click', function(){

    $('.globalDialog').removeClass('modal_isActive');
    $('body').removeClass('mix-globalDialogIsOpen');
    $('body').removeClass('mix-bodyIsLocked');
    $('body').removeClass('bodyIsLocked_dialog');
    $('body').removeClass('modalIsOpen');

    // iOS conditional bodylock removal
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        const bodyElement = document.querySelector('body');
        bodyElement.style.removeProperty('overflow');
        bodyElement.style.removeProperty('position');
        bodyElement.style.removeProperty('top');
        bodyElement.style.removeProperty('width');
        window.scrollTo(0, scrollTop);
    }
});